<template>
  <div>
    <form class="section__content form">
      <fieldset class="form__group">
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Your name</h1>
            <small class="form__item__description">What should we call you?</small>
          </label>

          <section class="form__item__input input">
            <input type="text" class="input__field"  v-model="name" />
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Current Email </h1>
            <small class="form__item__description">The email that is associated to your user.</small>
          </label>

          <section class="form__item__input input">
            <input type="email" class="input__field" v-model="email"/>
          </section>
        </article>
        <article class="form__item form__item--show-border" v-if="basicDirty">
          <a href="#" v-on:click.prevent="saveBasicDetails" class="section__footer__button button button--primary">Save</a>
          <a href="#" v-on:click.prevent="cancelBasicDetails" class="section__footer__button section__footer__button--right button button--secondary">Cancel</a>
        </article>
      </fieldset>
    </form>
    <form class="section__content form">
      <fieldset class="form__group">
        <article class="form__item form__item--show-border" v-if="false">
          <label class="form__item__label">
            <h1 class="form__item__name">Current password</h1>
          </label>

          <section class="form__item__input input">
            <password v-model="currentPassword" v-bind:match="null" v-bind:skipPasswordGrade="true" ref="currentPassword" />
          </section>
        </article>

        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">New password</h1>
          </label>

          <section class="form__item__input input">
            <password v-model="newPassword" v-bind:match="null" v-bind:skipPasswordGrade="false" ref="newPassword" />
          </section>
        </article>

        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Confirm new password</h1>
          </label>

          <section class="form__item__input input">
            <password v-model="confirmNewPassword" v-bind:match="newPassword" v-bind:skipPasswordGrade="false" ref="confirmNewPassword" />
          </section>
        </article>

        <article class="form__item form__item--show-border" v-if="(passwordDirty && currentPassword || !hasPassword) && validPassword && newPassword && newPassword == confirmNewPassword">
          <a href="#" v-on:click.prevent="savePassword" class="section__footer__button button button--primary">Save</a>
          <a href="#" v-on:click.prevent="cancelSavePassword" class="section__footer__button section__footer__button--right button button--secondary">Cancel</a>
        </article>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import store from '../store.js'
  import Password from './common/Password.vue'
  import {mapState} from 'vuex'

  let gradePassword = (password)=>{
      let score = 0;

      let grades = ['very weak', 'weak', 'ok', 'strong', 'very strong'];
      let colors = ['#8B0000', '#FF0000', '#CCCC00', '#83db4c', '#25a11a'];

      let hasNumbers = /\d/.test(password);
      let hasLowerCase = /[a-z]/.test(password);
      let hasUpperCase = /[A-Z]/.test(password);
      let hasSpecialCharacter = /[^a-z\d]+/i.test(password);
      let hasLength = password.length >= 8;

      if(hasNumbers) ++score;
      if(hasLowerCase) ++score;
      if(hasUpperCase) ++score;
      if(hasSpecialCharacter) ++score;
      if(hasLength) ++score;

      if (score >= grades.length) {
        score = (grades.length - 1);
      }

      return {
        name: grades[score],
        color: colors[score]
      }
  }

  export default {
    name: 'ProfileGeneral',
    components: {
      'password': Password
    },
    props: ['name', 'email'],
    data () {
      return {
        basicDirty: false,
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
        passwordDirty: null,
        validPassword: false
      }
    },
    mounted () {
      this.resetPasswordStates();
    },
    computed: {
      ...mapState(['me']),
      hasPassword(){
        // This always returns false right now
        return this.me.password;
      }
    },
    methods: {
      saveBasicDetails(e){
        e.preventDefault();
        let payload = {
          name: this.name,
          email: this.email
        };
        store.dispatch('users/updateBasicDetails', { userId: this.me.id, payload: payload })
        this.basicDirty = false;
      },
      cancelBasicDetails(e){
        e.preventDefault();
        this.name = this.me.name;
        this.email = this.me.email;
      },
      resetPasswordStates(){
        if(this.$refs.currentPassword) this.$refs.currentPassword.resetState();
        this.$refs.newPassword.resetState();
        this.$refs.confirmNewPassword.resetState();
        this.currentPassword = null;
        this.newPassword = null;
        this.confirmNewPassword = null;
        this.passwordDirty = false;
      },
      savePassword(e){
        e.preventDefault();
        let { newPassword, currentPassword, hasPassword } = this;
        store.dispatch('users/updatePassword', {userId: this.me.id, currentPassword, hasPassword, newPassword});
        this.resetPasswordStates();
      },
      cancelSavePassword(e){
        e.preventDefault();
        this.resetPasswordStates();
      }
    },
    watch: {
      name(newVal){
        if(newVal != this.me.name){
          this.basicDirty = true;
        } else {
          this.basicDirty = false;
        }
      },
      email(newVal) {
        if (newVal != this.me.email) {
          this.basicDirty = true;
        } else {
          this.basicDirty = false;
        }
      },
      currentPassword(newVal){
        // Temporarily Disabled because hasPassword() returns false always
        if(newVal == ''){
          this.passwordDirty = false;
        } else {
          this.passwordDirty = true;
        }
      },
      newPassword: function(newVal, oldVal){

        if(newVal == ''){
          this.passwordDirty = false;
        } else {
          this.passwordDirty = true;
        }

        let grade = gradePassword(newVal);

        this.passwordGrade = grade.name;
        this.passwordColor = grade.color;

        if(grade.name == 'very strong' || grade.name == 'strong'){
          this.validPassword = true;
        } else {
          this.validPassword = false;
        }
      }
    }
  }
</script>

<style scoped>
  .button--primary {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProfileGeneral.vue